import React from 'react';

export const ConfluenceAppSelectorIcon = (): React.JSX.Element => (
	<svg width="42" height="16" viewBox="0 0 42 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<mask id="path-1-inside-1_265_19690" fill="white">
			<path d="M26 4C26 1.79086 27.7909 0 30 0H38C40.2091 0 42 1.79086 42 4V12C42 14.2091 40.2091 16 38 16H30C27.7909 16 26 14.2091 26 12V4Z" />
		</mask>
		<path
			d="M26 4C26 1.79086 27.7909 0 30 0H38C40.2091 0 42 1.79086 42 4V12C42 14.2091 40.2091 16 38 16H30C27.7909 16 26 14.2091 26 12V4Z"
			fill="white"
		/>
		<path
			d="M30 0V1H38V0V-1H30V0ZM42 4H41V12H42H43V4H42ZM38 16V15H30V16V17H38V16ZM26 12H27V4H26H25V12H26ZM30 16V15C28.3431 15 27 13.6569 27 12H26H25C25 14.7614 27.2386 17 30 17V16ZM42 12H41C41 13.6569 39.6569 15 38 15V16V17C40.7614 17 43 14.7614 43 12H42ZM38 0V1C39.6569 1 41 2.34315 41 4H42H43C43 1.23858 40.7614 -1 38 -1V0ZM30 0V-1C27.2386 -1 25 1.23858 25 4H26H27C27 2.34315 28.3431 1 30 1V0Z"
			fill="#0B1228"
			fillOpacity="0.14"
			mask="url(#path-1-inside-1_265_19690)"
		/>
		<g clipPath="url(#clip0_265_19690)">
			<path
				d="M31.1425 9.2992C31.1425 9.874 30.6779 10.3386 30.1031 10.3386C29.5283 10.3386 29.0637 9.874 29.0637 9.2992C29.0637 8.72439 29.5283 8.25983 30.1031 8.25983H31.1425V9.2992ZM31.6621 9.2992C31.6621 8.72439 32.1267 8.25983 32.7015 8.25983C33.2763 8.25983 33.7409 8.72439 33.7409 9.2992V11.8976C33.7409 12.4724 33.2763 12.937 32.7015 12.937C32.1267 12.937 31.6621 12.4724 31.6621 11.8976V9.2992Z"
				fill="#E01E5A"
			/>
			<path
				d="M32.7016 5.12592C32.1268 5.12592 31.6622 4.66135 31.6622 4.08655C31.6622 3.51175 32.1268 3.04718 32.7016 3.04718C33.2764 3.04718 33.7409 3.51175 33.7409 4.08655V5.12592H32.7016ZM32.7016 5.65348C33.2764 5.65348 33.7409 6.11805 33.7409 6.69285C33.7409 7.26765 33.2764 7.73222 32.7016 7.73222H30.0953C29.5205 7.73222 29.0559 7.26765 29.0559 6.69285C29.0559 6.11805 29.5205 5.65348 30.0953 5.65348H32.7016Z"
				fill="#36C5F0"
			/>
			<path
				d="M36.8667 6.69285C36.8667 6.11805 37.3313 5.65348 37.9061 5.65348C38.4809 5.65348 38.9455 6.11805 38.9455 6.69285C38.9455 7.26765 38.4809 7.73222 37.9061 7.73222H36.8667V6.69285ZM36.3471 6.69285C36.3471 7.26765 35.8825 7.73222 35.3077 7.73222C34.7329 7.73222 34.2683 7.26765 34.2683 6.69285V4.08655C34.2683 3.51175 34.7329 3.04718 35.3077 3.04718C35.8825 3.04718 36.3471 3.51175 36.3471 4.08655V6.69285V6.69285Z"
				fill="#2EB67D"
			/>
			<path
				d="M35.3077 10.8583C35.8825 10.8583 36.3471 11.3228 36.3471 11.8976C36.3471 12.4724 35.8825 12.937 35.3077 12.937C34.7329 12.937 34.2683 12.4724 34.2683 11.8976V10.8583H35.3077ZM35.3077 10.3386C34.7329 10.3386 34.2683 9.874 34.2683 9.2992C34.2683 8.72439 34.7329 8.25983 35.3077 8.25983H37.914C38.4888 8.25983 38.9533 8.72439 38.9533 9.2992C38.9533 9.874 38.4888 10.3386 37.914 10.3386H35.3077Z"
				fill="#ECB22E"
			/>
		</g>
		<mask id="path-7-inside-2_265_19690" fill="white">
			<path d="M13 4C13 1.79086 14.7909 0 17 0H25C27.2091 0 29 1.79086 29 4V12C29 14.2091 27.2091 16 25 16H17C14.7909 16 13 14.2091 13 12V4Z" />
		</mask>
		<path
			d="M13 4C13 1.79086 14.7909 0 17 0H25C27.2091 0 29 1.79086 29 4V12C29 14.2091 27.2091 16 25 16H17C14.7909 16 13 14.2091 13 12V4Z"
			fill="white"
		/>
		<path
			d="M17 0V1H25V0V-1H17V0ZM29 4H28V12H29H30V4H29ZM25 16V15H17V16V17H25V16ZM13 12H14V4H13H12V12H13ZM17 16V15C15.3431 15 14 13.6569 14 12H13H12C12 14.7614 14.2386 17 17 17V16ZM29 12H28C28 13.6569 26.6569 15 25 15V16V17C27.7614 17 30 14.7614 30 12H29ZM25 0V1C26.6569 1 28 2.34315 28 4H29H30C30 1.23858 27.7614 -1 25 -1V0ZM17 0V-1C14.2386 -1 12 1.23858 12 4H13H14C14 2.34315 15.3431 1 17 1V0Z"
			fill="#0B1228"
			fillOpacity="0.14"
			mask="url(#path-7-inside-2_265_19690)"
		/>
		<g clipPath="url(#clip1_265_19690)">
			<path
				d="M16.4729 11.3855L16.9433 12.1939C17.0411 12.3641 17.1816 12.4978 17.3465 12.595L19.0266 9.70197H15.6665C15.6665 9.89038 15.7154 10.0788 15.8131 10.249L16.4729 11.3855Z"
				fill="#0066DA"
			/>
			<path
				d="M20.9998 6.2984L19.3198 3.40533C19.1549 3.50258 19.0143 3.63629 18.9166 3.80647L15.8131 9.155C15.7172 9.32151 15.6666 9.51008 15.6665 9.70201H19.0266L20.9998 6.2984Z"
				fill="#00AC47"
			/>
			<path
				d="M24.6534 12.595C24.8184 12.4978 24.9589 12.3641 25.0566 12.1939L25.2521 11.8596L26.1868 10.249C26.2846 10.0788 26.3335 9.89038 26.3335 9.70197H22.9731L23.6882 11.0999L24.6534 12.595Z"
				fill="#EA4335"
			/>
			<path
				d="M21.0001 6.29846L22.6801 3.40539C22.5152 3.30814 22.3258 3.25952 22.1303 3.25952H19.8699C19.6744 3.25952 19.485 3.31422 19.3201 3.40539L21.0001 6.29846Z"
				fill="#00832D"
			/>
			<path
				d="M22.9728 9.70197H19.0262L17.3462 12.595C17.5111 12.6923 17.7005 12.7409 17.896 12.7409H24.103C24.2985 12.7409 24.4878 12.6862 24.6528 12.595L22.9728 9.70197Z"
				fill="#2684FC"
			/>
			<path
				d="M24.6352 6.48074L23.0835 3.80647C22.9857 3.63629 22.8452 3.50258 22.6803 3.40533L21.0002 6.2984L22.9735 9.70201H26.3275C26.3275 9.5136 26.2786 9.32518 26.1808 9.155L24.6352 6.48074Z"
				fill="#FFBA00"
			/>
		</g>
		<mask
			id="path-15-outside-3_265_19690"
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="17"
			height="16"
			fill="black"
		>
			<rect fill="white" width="17" height="16" />
			<path d="M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z" />
		</mask>
		<path
			d="M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z"
			fill="#1868DB"
		/>
		<path
			d="M0 0H16H0ZM16 16H0H16ZM0 16V0V16ZM12 0C14.7614 0 17 2.23858 17 5V11C17 13.7614 14.7614 16 12 16C13.6569 16 15 14.2091 15 12V4C15 1.79086 13.6569 0 12 0Z"
			fill="white"
			mask="url(#path-15-outside-3_265_19690)"
		/>
		<g clipPath="url(#clip2_265_19690)">
			<g clipPath="url(#clip3_265_19690)">
				<g clipPath="url(#clip4_265_19690)">
					<path
						d="M5.98251 10.3493H5.08098C3.72128 10.3493 2.74585 9.51647 2.74585 8.29696H7.59345C7.8447 8.29696 8.00727 8.47543 8.00727 8.72825V13.6063C6.79537 13.6063 5.98251 12.6247 5.98251 11.2565V10.3493ZM8.37675 7.92516H7.47522C6.11552 7.92516 5.14009 7.1072 5.14009 5.8877H9.98769C10.2389 5.8877 10.4163 6.05129 10.4163 6.30412V11.1821C9.20439 11.1821 8.37675 10.2006 8.37675 8.83236V7.92516ZM10.7858 5.5159H9.88424C8.52455 5.5159 7.54911 4.68307 7.54911 3.46356H12.3967C12.648 3.46356 12.8105 3.64203 12.8105 3.87998V8.758C11.5986 8.758 10.7858 7.77644 10.7858 6.40822V5.5159Z"
						fill="white"
					/>
				</g>
			</g>
		</g>
		<defs>
			<clipPath id="clip0_265_19690">
				<rect width="10" height="10" fill="white" transform="translate(29.0002 3)" />
			</clipPath>
			<clipPath id="clip1_265_19690">
				<rect width="10.6667" height="9.48148" fill="white" transform="translate(15.6663 3.2594)" />
			</clipPath>
			<clipPath id="clip2_265_19690">
				<rect width="13" height="13" fill="white" transform="translate(1.5 1.5)" />
			</clipPath>
			<clipPath id="clip3_265_19690">
				<rect width="13" height="13" fill="white" transform="translate(1.5 1.5)" />
			</clipPath>
			<clipPath id="clip4_265_19690">
				<rect
					width="10.0647"
					height="10.1427"
					fill="white"
					transform="translate(2.74585 3.46356)"
				/>
			</clipPath>
		</defs>
	</svg>
);
